// extracted by mini-css-extract-plugin
export default {"root":"LoginForm_root__FcIG0","error":"LoginForm_error__rpbON","input":"LoginForm_input__vQjVf"};